// extracted by mini-css-extract-plugin
module.exports = {"section":"ThankYou_section__1Beav","header":"ThankYou_header__33KO1","title":"ThankYou_title__2k6sg","link":"ThankYou_link__3muOi","buttonWrap":"ThankYou_buttonWrap__1kCaA"};